let globalContext = null;

export class AppContext {
  setApi(api) {
    this.api = api;
  }
  getApi() {
    return this.api;
  }

  setUserStore(userStore) {
    this.userStore = userStore;
  }
  getUserStore() {
    return this.userStore;
  }

  setAudioStore(audioStore) {
    this.audioStore = audioStore;
  }
  getAudioStore() {
    return this.audioStore;
  }

  setPodcastStore(podcastStore) {
    this.podcastStore = podcastStore;
  }
  getPodcastStore() {
    return this.podcastStore;
  }
}

export default function global() {
  if (!globalContext) {
    globalContext = new AppContext();
  }
  return globalContext;
}
